import React, { useContext, useState } from 'react';
import { MemberContext } from '../../../context/member-context';
import UserIcon from '../../images/user.jpg';

import './member-nav-style.css';
import { Link } from 'react-router-dom';

const MemberNav = () => {
  const { auth, info, logout } = useContext(MemberContext);
  const [open, setOpen] = useState(false);

  function toggleOpen() {
    setOpen(!open);
  }

  function closeMenu() {
    setOpen(false);
  }

  if (auth.value) {
    return (
      <div className="member-nav">
        <div className={'member-nav-avatar'} onClick={toggleOpen}>
          {info.avatar.length === 0 ? <img src={UserIcon} alt={'User'} /> : <img src={info.avatar} alt={'User'} />}
        </div>
        {open && (
          <div>
            <div className="member-nav-closer" onClick={closeMenu} />
            <div className="member-menu">
              <div className="title">{info.fullname}</div>
              <ul>
                <li className="item" onClick={closeMenu}>
                  <Link to={`/member/profile`}>ویرایش حساب کاربری</Link>
                </li>
                <li className="item" onClick={closeMenu}>
                  <Link to={`/member/password`}>تغییر کلمه عبور</Link>
                </li>
                <li className="item" onClick={closeMenu}>
                  <a className="c-p color-danger" onClick={logout}>
                    خروج
                  </a>
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <Link to={'/member/login'}>
        <div className="member-nav">
          <div className={'member-nav-avatar'}>
            <img src={UserIcon} alt={'User'} />
          </div>
        </div>
      </Link>
    );
  }
};

export default MemberNav;
